import React, {Component} from 'react';
import PropTypes from 'prop-types';
import headerTemplate from './Header.rt';
import debounce from 'lodash/debounce';

export default class Header extends Component {
  static propTypes = {
    setTerm: PropTypes.func.isRequired,

    term: PropTypes.string.isRequired
  }
  constructor(props) {
    super(props);

    this.state = {
      term: ''
    }

    this.debouncedSearch = debounce(this.performSearch, 250);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.term !== this.state.term && this.props.term === '' && !this.settingTerm) {
      this.setState({term: ''});
    }
  }

  settingTerm = false;

  setSearchTerm = term => {
    this.settingTerm = true;
    this.setState({term}, () => {
      this.debouncedSearch(term);
      this.settingTerm = false;
    });
  }

  performSearch = (term) => {
    this.props.setTerm(term);
 }

  render = headerTemplate
}

